import styles from './MyOCLogin2018.module.css';
import { type DoneViewProps } from './types';

/**
 * Confirmation view ported from the legacy `done-view`. After signup it shows the "check your email to
 * verify" copy and no CTA (the user must act on the email); for the preferences journey it confirms the
 * update and offers a continue CTA. The legacy `thank-you.svg` is replaced with a CSS check mark.
 */
const DoneView: React.FC<DoneViewProps> = ({ journey, labelActions, onContinue }) => {
  const isSignup = journey === 'signup';

  return (
    <div className={styles.view}>
      <div className={styles.viewContent}>
        <div aria-hidden="true" className={styles.doneTick}>
          ✓
        </div>
        {isSignup ? (
          <p
            className={styles.doneMessage}
            dangerouslySetInnerHTML={{ __html: labelActions.get('AUTH_CHECK_EMAIL') }}
          />
        ) : (
          <p className={styles.doneMessage}>{labelActions.get('AUTH_THANKS_FOR_UPDATING')}</p>
        )}

        {!isSignup && (
          <div className={styles.buttonWrapper}>
            <button className={styles.ctaButton} onClick={onContinue} type="button">
              {labelActions.get('AUTH_CONTINUE_USING_ODDSCHECKER')}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DoneView;
